module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_13-7d27de9954488543356879ed1a88d412.jpg";